var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHeadsetIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3378F9;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.1,48h-1.1v-11C85.1,16.6,68.4,0,48,0S10.9,16.6,10.9,37.1v11H9.9C6.6,48,4,50.7,4,53.9v11.2 C4,68.3,6.6,71,9.9,71h7.9c1.1,3.7,4.6,6.4,8.6,6.4c5,0,9-4,9-9V50.7c0-5-4-9-9-9c-1.1,0-2.1,0.2-3,0.5v-5.1 c0-13.6,11.1-24.6,24.6-24.6s24.6,11,24.6,24.6v5.1c-1-0.3-2-0.5-3-0.5c-5,0-9,4-9,9v17.6c0,5,4,9,9,9c4.1,0,7.5-2.7,8.6-6.4h2.2 v6.4c0,5.4-4.4,9.7-9.7,9.7H59.2c-0.8-3-3.5-5.2-6.8-5.2h-8.9c-3.9,0-7,3.2-7,7c0,3.9,3.2,7,7,7h8.9c3.2,0,5.9-2.2,6.8-5.2h11.5 c7.4,0,13.5-6,13.5-13.5V71h1.9c3.2,0,5.9-2.6,5.9-5.9V53.9C92,50.7,89.4,48,86.1,48z M52.4,92.2h-8.9c-1.8,0-3.3-1.5-3.3-3.3 c0-1.8,1.5-3.3,3.3-3.3h8.9c1.8,0,3.3,1.5,3.3,3.3C55.7,90.8,54.2,92.2,52.4,92.2z M7.7,65.1V53.9c0-1.2,1-2.1,2.1-2.1h7.5v15.4H9.9 C8.7,67.2,7.7,66.3,7.7,65.1z M31.7,50.7v17.6c0,2.9-2.4,5.3-5.3,5.3s-5.3-2.4-5.3-5.3V50.7c0-2.9,2.4-5.3,5.3-5.3 S31.7,47.8,31.7,50.7z M48,8.7c-15.7,0-28.4,12.7-28.4,28.4v7.7c-0.8,0.9-1.5,2.1-1.8,3.3h-3.1v-11C14.7,18.7,29.6,3.8,48,3.8 s33.3,14.9,33.3,33.3v11h-3.1c-0.4-1.2-1-2.3-1.8-3.3v-7.7C76.4,21.4,63.7,8.7,48,8.7L48,8.7z M74.9,68.3c0,2.9-2.4,5.3-5.3,5.3 c-2.9,0-5.3-2.4-5.3-5.3V50.7c0-2.9,2.4-5.3,5.3-5.3s5.3,2.4,5.3,5.3V68.3z M88.3,65.1c0,1.2-1,2.1-2.1,2.1h-7.5V51.8h7.5 c1.2,0,2.1,1,2.1,2.1V65.1z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHeadsetIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/HeadsetIcon.b2a87b79.svg";
export { ForwardRef as ReactComponent };